import styled from '@emotion/styled'
import { CircularProgress, Fade } from '@mui/material'
import { tokens } from '../../theme.js'
const colors = tokens.colors
const borderRadius = tokens.borderRadius

const pad = { default: '10px 20px', short: '7px 20px', large: '13px 30px' }
const BaseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font: 500 14px/15px ${tokens.fonts.body};
  text-transform: none;
  cursor: pointer;
  white-space: nowrap;
  border-radius: ${borderRadius.button};
  padding: ${p => pad[p.padding] || pad.default};
  width: ${p => p.width || 'auto'};
  background: ${colors.primary};
  color: ${colors.white};
  border: 0.775px solid ${colors.primary};
  transition: background 0.15s ease;
  &:hover:not(:disabled) {
    background: ${colors.primary}CC;
  }
  &:disabled {
    background: ${colors.primary}99;
    cursor: default;
  }
  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 1px;
  }
  & .MuiSvgIcon-root {
    width: 18px;
    height: 18px;
  }
`
export function Button({ children, loading, disabled, padding = 'default', ...rest }) {
  return (
    <span style={{ position: 'relative', display: 'inline-flex' }}>
      <BaseButton padding={padding} disabled={disabled || loading} {...rest}>
        {children}
      </BaseButton>
      {loading && (
        <Fade in style={{ transitionDelay: '800ms' }}>
          <CircularProgress size={16} sx={{ color: colors.white, position: 'absolute', top: '50%', left: '50%', mt: '-8px', ml: '-8px' }} />
        </Fade>
      )}
    </span>
  )
}
export const SecondaryButton = styled(BaseButton)`
  background: ${colors.secondaryButton.background};
  color: ${colors.secondaryButton.text};
  border: 0.775px solid ${colors.secondaryButton.border};
  &:hover:not(:disabled) {
    background: ${colors.secondaryButton.hover};
    border-color: ${colors.secondaryButton.border}66;
  }
  &:disabled {
    background: ${colors.secondaryButton.disabled};
    opacity: 0.5;
  }
`
export const IconButton = styled(BaseButton)`
  padding: 6px;
  border-radius: ${borderRadius.iconButton};
  min-width: auto;
`
export const SecondaryIconButton = styled(IconButton)`
  background: ${colors.secondaryButton.background};
  color: ${colors.secondaryButton.text};
  border: 1px solid ${colors.text.muted};
  &:hover:not(:disabled) {
    background: ${colors.secondaryButton.hover};
  }
  &:disabled {
    background: ${colors.secondaryButton.disabled};
    opacity: 0.5;
  }
`
export const IconOnlyButton = styled(IconButton)`
  background: transparent;
  border: none;
  color: ${colors.text.body};
  &:hover:not(:disabled) {
    background: ${colors.background.medium};
  }
  &:disabled {
    background: transparent;
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }
`
export const TextButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${colors.text.link};
  text-decoration: underline;
  font: 500 14px/15px ${tokens.fonts.body};
  &:hover {
    color: ${colors.text.linkDisabled};
  }
`
export const LinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  border: none;
  padding: 8px 6px;
  cursor: pointer;
  color: ${colors.text.link};
  font: 500 14px/15px ${tokens.fonts.body};
  white-space: nowrap;
  &:hover:not(:disabled) {
    color: ${colors.text.linkDisabled};
  }
  &:disabled {
    color: ${colors.text.muted};
    cursor: default;
  }
  & .MuiSvgIcon-root {
    width: 18px;
    height: 18px;
  }
`
export const DangerButton = props => <Button {...props} style={{ background: colors.error, borderColor: colors.error, ...(props.style || {}) }} />
export const DangerOutlineButton = styled(SecondaryButton)`
  color: ${colors.error};
  background: ${colors.white};
  border-color: ${colors.error}80;
  &:hover:not(:disabled) {
    background: ${colors.white};
    border-color: ${colors.error};
  }
`
